import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../actions/navigationActions';
import {
    LIFE_INSURANCE_COVER, LIFE_INSURANCE_POLICY_DETAILS
} from '../../routes/routes';
import LifeInsuranceCover from './LifeInsuranceCover';

class LifeInsurancePolicyDetails extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            isInEdit: false,
        }
    }

    public render() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile && (this.props.router.location.pathname === LIFE_INSURANCE_POLICY_DETAILS)) {
            this.props.redirectTo(LIFE_INSURANCE_COVER);
        }

        return (
            <LifeInsuranceCover />
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeInsurancePolicyDetails);